import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

// Schema
import MainApiService from "../../../../../services/mainApi.service";
import {
  FormContainer,
  FormInput,
  SwitchInput,
  useFetch,
} from "@4uhub/lib4uhub";
import { listCategorySchema, TListCategoryForm } from "./listCategorySchema";

const LIST_CATEOGRY_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListCategory/";
const listCategoryService = new MainApiService<TListCategoryForm>(
  LIST_CATEOGRY_ROUTE
);

const translationPath = "page.4uDlist.listCategory.";

const ListCategory = () => {
  const { t } = useTranslation();

  const { sendRequest: save, loading: sLoading } = useFetch(
    listCategoryService.create
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    listCategoryService.updateItemById
  );
  const { sendRequest: get, loading: gLoading } = useFetch(
    listCategoryService.getItemById
  );

  const updateHandler = (v: TListCategoryForm, id: string) =>
    update({ item: v, id: id });

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TListCategoryForm>
      saveFunction={save}
      updateFunction={updateHandler}
      getFunction={get}
      loading={loading}
      title={t(translationPath + "list_category")}
      schema={listCategorySchema}
      subtitle={t(translationPath + "new")}
      subtitleWatchField={"name"}
      fields={() => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <SwitchInput
              name="enable"
              label={t(translationPath + "enable") || "Enable"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              fullWidth
              label={t(translationPath + "name") || "Name"}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="description"
              fullWidth
              multiline
              minRows={4}
              label={t(translationPath + "description") || "Description"}
            />
          </Grid>
        </Grid>
      )}
    />
  );
};

export default ListCategory;
